import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * La raíz no tiene vista propia todavía: el dashboard es F6. Hasta entonces lleva a "Mis
 * tareas", que es la vista diaria, en vez de a un cartel que no deja ir a ninguna parte.
 */
export const Route = createFileRoute('/_authed/')({
  beforeLoad: () => {
    throw redirect({ to: '/my' });
  },
});
